import type { Presentation, SlideMasterProps } from '@features/powerpoint';
import type { ImageWithMetadata } from '@features/powerpoint';
import {
  slideMasterV2,
  slideMasterNoLogoV2,
} from '@features/lci-report/slides/slide-master-v2';
import {
  sectionTitleSlideMasterV2,
  SECTION_HEADER,
} from '@features/lci-report/slides/shared/section-title-slide-master-v2';
import {
  sectionHeaderBlankSlideMasterV2,
  SECTION_HEADER_BLANK,
} from '@features/lci-report/slides/shared/section-header-blank-slide-master-v2';
import { layout } from '@features/lci-report/domain/dimensions';
import { DEFAULT_FONT } from '@features/lci-report/utils/constants-v2';

export const MASTER_NAMES = {
  titleAndContent: 'InMarket_Title and Content',
  titleAndContentNoLogo: 'InMarket_Title and Content - No Logo',
  sectionHeader: SECTION_HEADER,
  sectionHeaderBlank: SECTION_HEADER_BLANK,
} as const;

type SharedPresentationV2Props = {
  campaign: {
    id: number;
    name: string;
  };
  brandLogo: ImageWithMetadata | null;
};

export const createSharedPresentationConfigV2 = (
  props: SharedPresentationV2Props
): {
  filename: string;
  theme: { headFontFace: string; bodyFontFace: string };
  layout: Presentation['layout'];
  slideMasters: SlideMasterProps[];
} => {
  const { campaign, brandLogo } = props;
  const campaignName = campaign.name;

  return {
    filename: `${campaignName}_lci_report.pptx`,
    theme: { headFontFace: DEFAULT_FONT, bodyFontFace: DEFAULT_FONT },
    layout,
    slideMasters: [
      slideMasterV2(brandLogo),
      slideMasterNoLogoV2(),
      sectionTitleSlideMasterV2,
      sectionHeaderBlankSlideMasterV2,
    ],
  };
};
